export default __webpack_public_path__ + "static/media/testrocketsLogo.303aa8fc.png";